import { render, staticRenderFns } from "./BodegaListadoDevoluciones.vue?vue&type=template&id=c6d137d6"
import script from "./BodegaListadoDevoluciones.vue?vue&type=script&lang=js"
export * from "./BodegaListadoDevoluciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports